import Swiper, { Autoplay, EffectFade } from "swiper";
Swiper.use([Autoplay, EffectFade]);
import "swiper/css/bundle";

export const HomeFunction = () => {
  const body = document.querySelector("body");

  window.addEventListener("load", () => {
    body.classList.add("is--loaded");
  });

  const mvSwiper = new Swiper(".js-mv-swiper", {
    loop: true,
    effect: "fade",
    speed: 1000,
    slidesPerView: 1,

    autoplay: {
      delay: 3000,
    },
  });
};
